/**
 * InvestingStylesService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class InvestingStyleService {
    getInvestingStyles = (body) => {
        return apiClient.post("/context/investingStyle/get", body);
    }
}
